/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import favicon from "../images/favicon.ico"

function SEO({ description, lang, meta, title }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      link={[
        {rel: 'icon', type: 'image/png', href: `${favicon}`}
      ]}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `google-site-verification`,
          content: `9xrLjraIUHjaWTKgthquV-tHCeR-EHDwLog7z8d-nkw`,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      <script type="text/javascript">
        {`
          window._monsido = window._monsido || {
              token: "3nB6PNxaWjju2ghE0BlVdQ",
              pageAssistV2: {
                  enabled: true,
                  theme: "light",
                  mainColor: "#000000",
                  textColor: "#ffffff",
                  linkColor: "#1275b3",
                  buttonHoverColor: "#1275b3",
                  mainDarkColor: "#052942",
                  textDarkColor: "#ffffff",
                  linkColorDark: "#FFCF4B",
                  buttonHoverDarkColor: "#FFCF4B",
                  greeting: "Discover your personalization options",
                  direction: "leftbottom",
                  coordinates: "   ",
                  iconShape: "circle",
                  title: "Personalization Options",
                  titleText: "Welcome to PageAssist™ toolbar! Adjust the options below to cater the website to your accessibility needs.",
                  iconPictureUrl: "logo",
                  logoPictureUrl: "",
                  logoPictureBase64: "",
                  languages: ["en-US"],
                  defaultLanguage: "en-US",
                  skipTo: false,
                  alwaysOnTop: false,
              },
          };
        `}
      </script>
      <script type="text/javascript" async src="https://app-script.monsido.com/v2/monsido-script.js"></script>
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
